import * as actions from '../../actions/actionTypes';
//
const initialState = [];
//
export default function depthByRegion(state = initialState, action) {
  switch (action.type) {
    case actions.SET_2ND_DEPTHBYREGION_SUCCESS:
      if (action.payload) {
        return action.payload;
      } else {
        return state;
      }
    case actions.SET_2ND_DEPTHBYREGION_FAILURE:
      return state;
    default:
      return state;
  }
}
